module.exports = __webpack_public_path__ + "static/media/hint-icon.8785f7eb.svg";